var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Head'),(!_vm.isReady)?_c('Spinner'):_vm._e(),(_vm.isReady)?_c('main',{attrs:{"role":"main"}},[_c('PlayerSelection'),_c('BoxVersus'),_c('FilterRow'),_c('RankGraph'),_c('Timeline'),_c('Authors'),_c('Footer')],1):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5aea572","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/app/components/Main/Main.html
// module id = null
// module chunks = 